import Vue from 'vue'
import * as ModuleRepository from './moduleRepository.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../css/kiss/design.scss';
import { Loading } from 'element-ui';

require('babel-polyfill');
require('date-input-polyfill');
require('es6-promise').polyfill();

Vue.use(ElementUI);

try {
    let domain = UserHelper.getDomain();
    //optional override css for client
    require('../css/clients/hssyportal_'+ domain + '.css');
}catch(err) {
    //Nothing, custom css not exit
}



window.GlobalEventBus = new Vue(); //Global Event Bus to communicate between separate components (no relation parent/child, in this case use "props")

/** Register all components  VueJs **/
window.instantiateReportClientComponent= ModuleRepository.instantiateReportClientComponent;
window.destroyReportClientComponent= ModuleRepository.destroyReportClientComponent;

window.instantiateUserDetailsComponent= ModuleRepository.instantiateUserDetailsComponent;
window.destroyUserDetailsComponent= ModuleRepository.destroyUserDetailsComponent;

window.instantiateLoginComponent= ModuleRepository.instantiateLoginComponent;
window.destroyLoginComponent= ModuleRepository.destroyLoginComponent;

window.instantiateArkeviaRegisterComponent= ModuleRepository.instantiateArkeviaRegisterComponent;
window.destroyArkeviaRegisterComponent= ModuleRepository.destroyArkeviaRegisterComponent;

window.instantiateArkeviaUserAccountComponent= ModuleRepository.instantiateArkeviaUserAccountComponent;
window.destroyArkeviaUserAccountComponent= ModuleRepository.destroyArkeviaUserAccountComponent;

window.instantiateConfirmdisableComponent= ModuleRepository.instantiateConfirmdisableComponent;
window.destroyConfirmdisableComponent= ModuleRepository.destroyConfirmdisableComponent;

window.instantiateSharedownloadComponent= ModuleRepository.instantiateSharedownloadComponent;
window.destroySharedownloadComponent= ModuleRepository.destroySharedownloadComponent;

window.instantiateBottomDetailsComponent= ModuleRepository.instantiateBottomDetailsComponent;
window.destroyBottomDetailsComponent= ModuleRepository.destroyBottomDetailsComponent;

window.instantiateMigrationWelcomeComponent=ModuleRepository.instantiateMigrationWelcomeComponent;
window.destroyMigrationWelcomeComponent=ModuleRepository.destroyMigrationWelcomeComponent;


//Event for show loading cursor
let loadingInstance;

window.GlobalEventBus.$on('activeloading', function (msg) {
    loadingInstance = Loading.service({ fullscreen: false });
})

window.GlobalEventBus.$on('deactiveloading', function (msg) {
    if(loadingInstance)
        loadingInstance.close();
})


window.GlobalEventBus.$on('notify', function (msg,type,callback) {
    this.$notify({
        title: '',
        message: msg,
        type: type,
        duration: 5000,
        position: 'bottom-right',
        speed : 500,
        onClick : callback
    });
});

window.GlobalEventBus.$on('closeAllNotification', function () {
    this.$notify.closeAll();
});





// WEBPACK FOOTER //
// ./portal/src/main.js